import gql from "graphql-tag"
import SourceAssetFragment from "../fragment/SourceAssetFragment"

export default gql`
  ${SourceAssetFragment}
  query sourceAssetList($status: SourceAssetStatusEnum) {
    sourceAssetList(status: $status) {
      ...SourceAssetFragment
    }
  }
`
